import React from "react";

// API
import {CustomFieldValueDto} from "../../../api/models/CustomFieldValueDto";

const BookingDetailComponent: React.FC<any> = (props: any) => {
  const activityName: string = props.acceptedTransaction.activityName;
  const activitySessionLabel: string | null = props.acceptedTransaction.activitySessionLabel;
  const unitName: string = props.acceptedTransaction.unitName ? props.acceptedTransaction.unitName : props.acceptedTransaction?.ticketsCount == 1 ? "plaça" : "places";

  const activityNameDescription: string | null = props.acceptedTransaction
    ? activityName !== "" && !activitySessionLabel
      ? activityName
      : activitySessionLabel && activityName === ""
        ? activitySessionLabel
        : activitySessionLabel && activityName !== "" ? activityName + " - " + activitySessionLabel
          : ""
    : "";

  return (
    <div className="bg-white border rounded px-4 py-3 mt-3">
      <h3 className="text-success">
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 16 16"
          className="bi bi-check2-circle"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M15.354 2.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L8 9.293l6.646-6.647a.5.5 0 0 1 .708 0z"
          />
          <path
            fillRule="evenodd"
            d="M8 2.5A5.5 5.5 0 1 0 13.5 8a.5.5 0 0 1 1 0 6.5 6.5 0 1 1-3.25-5.63.5.5 0 1 1-.5.865A5.472 5.472 0 0 0 8 2.5z"
          />
        </svg>{" "}
        Confirmació de la reserva
      </h3>

      <hr className="my-3" />

      <p>
      {props.acceptedTransaction?.status === 3 && (
          <div>
            <br />
            <div className="alert alert-success">
              T'hem enviat un correu electrònic amb la confirmació de la
              reserva.
            </div>
          </div>
        )}
        {props.acceptedTransaction?.status === 2 && (
          <div>
            <br />
            <div className="alert alert-danger">
              La seva reserva s'ha processat correctament però hi ha hagut un
              error en l'enviament del correu electrònic.
            </div>
          </div>
        )}
      </p>

        {!props.acceptedTransaction?.htmlResponse && (
          <div>
            Moltes gràcies,
            <br />
            S'ha/n reservat{" "}
            <strong>{props.acceptedTransaction?.ticketsCount + " " + unitName}</strong> per
            a{" "}
            <strong>
              {activityNameDescription}
            </strong>
            .<br />
            
            <strong>Data i hora:</strong>
            <br />
            El {props.acceptedTransaction?.activitySessionStartOnDate} a les{" "}
            {props.acceptedTransaction?.activitySessionStartOnTime}h{" "}
            {props.acceptedTransaction?.activitySessionEndOnTime !== "" &&
              "i fins a les " + props.acceptedTransaction?.activitySessionEndOnTime}
            <br />
            <br />
            <strong>Ubicació:</strong>
            <br />
            {props.acceptedTransaction?.venueName}
            <br />
            {props.acceptedTransaction?.venueAddress}
            <br />
            {props.acceptedTransaction?.venueMapUrl != null && (
              <React.Fragment>
                <a href={props.acceptedTransaction?.venueMapUrl} target="_blank" rel="noopener noreferrer">
                  Veure mapa
                </a>
                <br />
              </React.Fragment>
            )}
    
            <hr className="my-3" />
      
            <p>
              <strong className="d-block small-title">
                Informació de la reserva
              </strong>
              
              <small>
                Codi de reserva: {props.acceptedTransaction?.transactionCode}
                <br />
                Data i hora reserva: {
                  props.acceptedTransaction?.transactionDateDate
                }{" "}
                {props.acceptedTransaction?.transactionDateTime}
                <br />
                Núm. de {unitName} reservades:{" "}
                {props.acceptedTransaction?.ticketsCount?.toString()}{" "}
                {props.acceptedTransaction?.discountName &&
                  (props.acceptedTransaction?.discountname != null ||
                  props.acceptedTransaction?.discountName !== ""
                    ? "(" + props.acceptedTransaction?.discountName + ")"
                    : null)}
                <br />
                Nom de l’usuari: {props.acceptedTransaction?.name}
                <br />
                DNI de l’usuari: {props.acceptedTransaction?.id}
                <br />
                Correu de l’usuari: {props.acceptedTransaction?.email}
                <br />
                Telèfon de l’usuari: {props.acceptedTransaction?.phone}
                <br/>
                </small>
                {(props.acceptedTransaction?.customFields && props.acceptedTransaction?.customFields.length > 0) && (
                  props.acceptedTransaction?.customFields.map((customField: CustomFieldValueDto, i: number) => {
                    return <small key={i}>{customField.customFieldCaption + ": " + (customField.value === "0" ? "No" : customField.value === "1" ? "Sí" : customField.value)}<br/></small>;
                    // return <small key={customField.customFieldIndex}>{customField.customFieldCaption + ": " + (customField.value === "0" ? "No" : customField.value === "1" ? "Sí" : customField.value)}<br/></small>;
                }))}
            </p>
          
            <p>
              <strong className="d-block small-title">
                Informació de l'activitat
              </strong>

              <small>
                Nom de l'activitat: {activityNameDescription}
                <br />
                Organitzador: {props.acceptedTransaction?.organizationName} (
                {props.acceptedTransaction?.venuePhone})
                <br />
                Data i hora inici/entrada:{" "}
                {props.acceptedTransaction?.activitySessionStartOnDate} a les{" "}
                {props.acceptedTransaction?.activitySessionStartOnTime}h
                {props.acceptedTransaction?.activitySessionEndOnTime !== "" && (
                  <React.Fragment>
                    <br />
                    Data i hora fi/sortida:{" "}
                    {props.acceptedTransaction?.activitySessionEndOnDate}a les{" "}
                    {props.acceptedTransaction?.activitySessionEndOnTime}
                  </React.Fragment>
                )}
                <br />
                Ubicació: {props.acceptedTransaction?.venueName} -{" "}
                {props.acceptedTransaction?.venueAddress}
              </small>
            </p>

          {props.acceptedTransaction?.activitySessionInfo && (
            <p>
              <small>
                {props.acceptedTransaction?.activitySessionInfo}
              </small>
            </p>
          )}

          <hr className="my-3" />
          
          <p>
            Fins aviat,
            <br />
            {props.acceptedTransaction?.organizationName}
          </p>
          </div>
        )}

      {props.acceptedTransaction?.htmlResponse && (
        <div dangerouslySetInnerHTML={{__html: props.acceptedTransaction.htmlResponse}}></div>
      )}


    </div>
  );
};

export default BookingDetailComponent;
